<template>
  <div class="home">
    <Hero />

    <section class="events-section">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">📅 活动列表</h2>
          <p class="section-subtitle">{{ siteSubtitle }}</p>
        </div>

        <div v-if="loading" class="loading-state">
          <p>加载中...</p>
        </div>

        <div v-else class="events-grid">
          <EventCard
            v-for="event in events"
            :key="event.id"
            :event="event"
            @view-detail="goToEvent"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Hero from '@/components/Hero.vue'
import EventCard from '@/components/EventCard.vue'
import eventsData from '@/data/events.json'

export default {
  name: 'Home',
  components: {
    Hero,
    EventCard
  },
  data() {
    return {
      events: [],
      loading: true
    }
  },
  computed: {
    // 取最新活动的 subtitle，按 dateRange.start 倒序
    siteSubtitle() {
      const sorted = [...eventsData].sort((a, b) => {
        const da = new Date(a.dateRange.start)
        const db = new Date(b.dateRange.start)
        return db - da
      })
      return sorted[0]?.subtitle || '三十一载同窗情'
    }
  },
  async mounted() {
    this.events = eventsData
    this.loading = false
  },
  methods: {
    goToEvent(eventId) {
      this.$router.push(`/event/${eventId}`)
    }
  }
}
</script>

<style scoped>
.home {
  min-height: 100vh;
  background: #F0F4F8;
}

.events-section {
  padding: 60px 0;
}

.section-header {
  text-align: center;
  margin-bottom: 50px;
}

.section-title {
  font-size: 32px;
  color: #1A2332;
  margin: 0 0 10px 0;
}

.section-subtitle {
  font-size: 16px;
  color: #666;
  margin: 0;
}

.events-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 30px;
}

.loading-state {
  text-align: center;
  padding: 60px;
  color: #666;
  font-size: 16px;
}

@media (max-width: 768px) {
  .events-section {
    padding: 40px 0;
  }

  .section-title {
    font-size: 24px;
  }

  .events-grid {
    grid-template-columns: 1fr;
  }
}
</style>
